/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React, { FC } from 'react'

import { routes } from '@builddocs/data-management'
import { useTestAuth } from '@builddocs/data-management-auth'
import { useIsIframe } from '@builddocs/system'
import { CrossStorageHub } from 'cross-storage'
import { RouteProps } from 'react-router-dom'

import { InformationProvider } from '../../providers'
import { YMParamsProvider } from '../../providers/YMProvider'

import LoadingSpinner from './LoadingSpinner'

type PrivateRouteProps = RouteProps & {
  component: React.ComponentType<any>
}

const PrivateRoute: FC<PrivateRouteProps> = ({ component: Component }) => {
  const isIframe = useIsIframe()
  const { isAuth } = useTestAuth({
    loginUrl: routes.auth.signIn(),
    redirectUrlOnSuccess: routes.account.base(),
    isPrivateRoute: true,
  })

  CrossStorageHub.init([
    {
      origin: /builddocs\.(team|online)$/,
      allow: ['get'],
    },
    {
      origin: /http:\/\/localhost:\d+$/,
      allow: ['get', 'set'],
    },
  ])

  if (isIframe) {
    return isAuth ? <Component /> : <LoadingSpinner isLogo height="100vh" />
  }

  if (isAuth) {
    return (
      <InformationProvider>
        <YMParamsProvider>
          <Component />
        </YMParamsProvider>
      </InformationProvider>
    )
  }

  return <LoadingSpinner isLogo height="100vh" />
}

export default PrivateRoute
